import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-surface" data-id="element-109" data-mp="3ggk72reij5xy">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10 text-center" data-id="element-110" data-mp="32nuh6bvv5gvk">
        <p className="flex items-center justify-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-accent" data-id="element-111" data-mp="32m1awxp5wyo3">
          <BookOpenIcon size={18} className="text-gold" data-id="element-112" data-mp="3ueilfwsu32dg" />
          {PRODUCT}
        </p>
        <p className="mt-2 text-sm font-bold uppercase tracking-[0.2em] text-ink" data-id="element-113" data-mp="38h2z36jh6hs">
          Leé. Comprendé. Reflexioná. Aplicá.
        </p>
        <p className="mx-auto mt-4 max-w-2xl font-display text-lg italic text-ink-muted" data-id="element-114" data-mp="3ldkeb5n3meqn">
          “No se trata solamente de leer más. Se trata de comprender mejor lo
          que leés y aprender a llevarlo a tu vida.”
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-muted" data-id="element-115" data-mp="2a1jl9ej7c453">
          Creado por CM Digital Pro™ — recursos digitales para quienes desean
          acercarse a las Escrituras de una manera clara, sencilla y práctica.
        </p>
        <p className="mt-3 text-sm text-ink-muted" data-id="element-116" data-mp="3gb8vj0znlauj">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-accent underline decoration-lineStrong underline-offset-4 transition-colors duration-150 ease-soft hover:text-accent-strong" data-id="element-117" data-mp="3v7q2zh4q25bt">
            {SUPPORT_EMAIL}
          </a>
        </p>

        <div className="mt-8 border-t border-line pt-5 text-xs leading-relaxed text-ink-subtle" data-id="element-118" data-mp="33xd9vvh5urg">
          <p data-id="element-119" data-mp="322zr2mj94xe">© 2026 CM Digital Pro™. Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-120" data-mp="hs1yp7lwwkdx">
            Prohibida la reproducción, copia o redistribución del material sin
            autorización expresa.
          </p>
          <p className="mt-1" data-id="element-121" data-mp="qsqd43f7wmrc">
            {PRODUCT} es un producto educativo de estudio y reflexión bíblica.
            No garantiza resultados personales o espirituales específicos.
          </p>
          <p className="mt-1" data-id="element-122" data-mp="tvw66chqp7dv">
            Este sitio no forma parte de Facebook ni de Meta Platforms, Inc. y
            no está respaldado, patrocinado ni administrado por dichas
            compañías.
          </p>
        </div>
      </div>
    </footer>;
}